<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      show-footer
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{
        enabled: !disabled && planningDisabled,
        trigger: 'click',
        mode: 'row',
      }"
      :height="220"
      border
      :edit-rules="validRules"
      :footer-method="() => footerData"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="d-flex pt_6 mb-2 side_frame_div">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #6C6C6C ;line-height: 25px; ">
              {{ $l('table_sku_header_sample') || '企划样品需求明细' }}
            </span>
          </div>
          <div>
            <b-button
              class="mr-2 ml-2"
              size="sm"
              variant="outline-success"
              @click="addNewsRow()"
              v-if="!disabled && planningDisabled"
              ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add, format } from '@/libs/util.number.js'
export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    planningDisabled: { type: Boolean, default: false },
    amzFirstDemandDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      calcTableData: [],
      tableColumns: tableColumns(this),
      format: (number) => format(number),

      validRules: {
        demandQty: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_sample_must_be_greater_than_0') ||
              '样品数量须大于0',
          },
        ],
        demandDate: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('tip_select_demandDate') || '请选择需求日期',
          },
        ],
        proofingType: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('tip_select_Sample') || '请选择样品类型',
          },
        ],
      },
    }
  },
  mounted() {},
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.calcTableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[2] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    setData(data) {
      this.tableData = data
      this.calcTableData = data
    },
    async resetCalcTable() {
      this.calcTableData = await this.getTableData()
      this.$refs.itemTable.updateFooter()
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({}, -1)
      await $itemTable.setActiveCell(newRow, 'demandDate')
      this.resetCalcTable()
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
      this.resetCalcTable()
    },

    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },

    async subTotAmount() {
      const data = this.getTableData()
      const demandQty = data.reduce(
        (result, next) => add(result, next.demandQty),
        0
      )
      this.resetCalcTable()
      this.$emit('updateDemandQty', demandQty)
    },
  },
}
</script>

<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.side_frame_div {
  height: 25px;
}
</style>
